import { useContext } from 'react';
import PWAContext from '../context/pwaContext';

/**
 * usePWAContext is a convenience hook to access the PWA context
 */
export default function usePWAContext() {
  return useContext(PWAContext);
}
